import { useState } from 'react';
import PropTypes from 'prop-types';
import { StyledModalComponent } from '@dnhb/node_package';
import styled from '@emotion/styled';

const H1 = styled.h1(props => ({
  color: props.theme.primaryColor,
  fontWeight: '600',
  fontSize: '30px',
  marginBottom: '22px',
}));

const Button = styled.button(props => ({
  color: props.theme.primaryColor,
  fontFamily: props.theme.fontFamily,
  fontSize: '12px',
  lineHeight: '14px',
  cursor: 'pointer',
}));

const defaultToolDisclaimer = (
  <>
    <p>
      Ondanks de constante zorg en aandacht die wij besteden aan de
      samenstelling van deze tool en de daarin gevraagde gegevens,
      kunnen wij niet instaan voor de volledigheid, juistheid of
      voortdurende actualiteit van de gegevens. Wij aanvaarden dan
      ook geen aansprakelijkheid voor enigerlei directe of indirecte
      schade, van welke aard ook, die voortvloeit uit of in enig
      opzicht verband houdt met het gebruik van deze tool.
    </p>
    <p>Je adviseur kan een exacte berekening voor je maken.</p>
  </>
)

export default function Disclaimer({ settings, toolSpecificDisclaimer }) {
  const [isOpen, closeModal] = useState(false);

  const toggleModal = () => {
    closeModal(!isOpen);
  };

  return (
    <>
      <Button type="button" onClick={() => toggleModal()}>
        Disclaimer
      </Button>
      <StyledModalComponent isOpen={isOpen} onRequestClose={toggleModal} maxWidth={540}>
        <H1>Disclaimer</H1>
        {settings.customDisclaimer ? (
          <span css={{ whiteSpace: 'pre-wrap' }}>{settings.disclaimerText}</span>
        ): (
          <div>
            {toolSpecificDisclaimer ? toolSpecificDisclaimer : defaultToolDisclaimer}
          </div>
        )}
      </StyledModalComponent>
    </>
  );
}

Disclaimer.propTypes = {
  children: PropTypes.node,
  settings: PropTypes.shape({}),
  toolSpecificDisclaimer: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

Disclaimer.defaultProps = {
  settings: {},
  toolSpecificDisclaimer: '',
}
